module.exports = __webpack_public_path__ + "static/img/right.9cd1b740.png";